const ExtDeminimis = {
    init: function() {
        "use strict";
        $(document)
            .on("modal.button.miniform.close.pre", function(e, data) {
                if (data.hasOwnProperty("miniformId")) {
                    const miniformId = parseInt(data["miniformId"]);
                    if (112 !== miniformId) {
                        return;
                    }

                    const datumOd = $("#modal-datumod");
                    if (!datumOd.length) {
                        return;
                    }

                    let url = window.location.protocol + "//" + window.location.host;
                    url += "/plugin/PluginDeMinimis/ajaxGeneratePeriods";

                    const idSection = $("#idSection").val();
                    const idItem = $("#idItem").val();
                    const ch = $("#_ch").val();
                    url += "/" + idSection;
                    url += "/" + idItem;
                    url += "?_ch=" + ch;

                    $.ajax({
                        type: "post",
                        url: url,
                        data: { datumOd: datumOd.val() },
                        dataType: "json",
                        global: true,
                        beforeSend: function() {
                            Lemo_Alert.addInfo("DeMinimis - generuji období", "DeMinimisGenerateSupportsBeforeSend");
                        },
                        complete: function() {
                            Lemo_Alert.closeById("DeMinimisGenerateSupportsBeforeSend");
                        },
                        success: function(r) {
                            if (r.hasOwnProperty("status") && true === r.status) {
                                DynaCore_Item.miniformReload(102, 83);
                            }
                            if (r.hasOwnProperty("messages")) {
                                Lemo_Alert.addMany(r.messages);
                            }
                        },
                        error: function() {
                            Lemo_Alert.addDanger("DeMinimis - generování období selhalo ...", "DeMinimisGenerateSupportsError");
                        }
                    });
                }
            });
    }
};

$(document).ready(function() {
    ExtDeminimis.init();
});
